import { render, staticRenderFns } from "./tableRowStyle.vue?vue&type=template&id=0486c18b&"
import script from "./tableRowStyle.vue?vue&type=script&lang=ts&"
export * from "./tableRowStyle.vue?vue&type=script&lang=ts&"
import style0 from "./tableRowStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports